import React from 'react';
import { AnimatePresence } from 'framer-motion';
import {
  TabPanelBlock,
  TabPanel,
  ContactUl,
  Contactli,
  ContactLink,
  ContactIcon,
} from './styles/BannerAsideTabBlock.styled';
import SmartPhoneIcon from '../assets/svg/mobilephone.svg';
import MessageIcon from '../assets/svg/cmessage.svg';
import ContactSVGIcon from '../assets/svg/wcontact.svg';

export default function AsideMenuContactUs({ isVisible, lang, dir }) {
  const isArabic = lang === 'ar';
  const variants = {
    isOpen: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.3,
        ease: 'linear',
      },
    },
    isClosed: {
      opacity: 0,
      x: 300,
      transition: {
        duration: 0.3,
        ease: 'linear',
      },
    },
  };
  return (
    isVisible && (
      <AnimatePresence>
        <TabPanelBlock variants={variants} initial="isClosed" animate="isOpen" exit="isClosed">
          <TabPanel dir={dir}>
            <ContactUl>
              <h5 dir={dir}>{isArabic ? 'تواصل معنا' : 'Contact Us'}</h5>
              <Contactli>
                <ContactLink dir={dir}>
                  <ContactIcon className="smarticon">
                    <SmartPhoneIcon />
                  </ContactIcon>
                  <p dir={dir} className="call_us">
                    {isArabic ? 'اتصل بنا' : 'Call Us'}
                    <br />
                    800 DWTC (3982)
                  </p>
                </ContactLink>
              </Contactli>
              <Contactli>
                <ContactLink href="mailto:info@dwtc.com" dir={dir}>
                  <ContactIcon className="message">
                    <ContactSVGIcon />
                  </ContactIcon>
                  <p>{isArabic ? 'أرسل لنا رسالة' : 'Send us a message'}</p>
                </ContactLink>
              </Contactli>
              <Contactli>
                <ContactLink href={`/${lang}/contact/`} dir={dir}>
                  <ContactIcon className="enquiryicon">
                    <MessageIcon />
                  </ContactIcon>
                  <p>{isArabic ? 'أرسل استفسارك' : 'Send your enquiry'}</p>
                </ContactLink>
              </Contactli>
            </ContactUl>
          </TabPanel>
        </TabPanelBlock>
      </AnimatePresence>
    )
  );
}
